"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAPreOrderPlanInsuranceItemDetailsComponent = void 0;
const orderStatus_service_1 = require("../../../services/orderStatus.service");
class CSMMAPreOrderPlanInsuranceItemDetailsComponent {
    constructor(orderService) {
        this.orderService = orderService;
    }
    ngOnChanges() {
        if (this.itemId) {
            this.getAppleCarePrice(this.itemId);
        }
    }
    getAppleCarePrice(devicId) {
        this.orderService.getAppleCareDetails(devicId).subscribe((response) => {
            this.itemPrice = response === null || response === void 0 ? void 0 : response.monthlyPrice;
        });
    }
}
exports.CSMMAPreOrderPlanInsuranceItemDetailsComponent = CSMMAPreOrderPlanInsuranceItemDetailsComponent;
//# sourceMappingURL=preorder-plan-insurance-item-details.component.js.map